"use client";

import { Link } from "react-router-dom";
import Profile from "./Profile";
import HorizontalNavbar from "./HorizontalNavbar";
import CartIcon from "../../eCommerce/Cart/CartIcon";
import { useEffect, useState } from "react";
import { ReferralActions } from "./Profile/ReferralActions";

const TopNavbar = ({ toggleActive } : { toggleActive:() => void }) => {
  const [referralCode, setReferralCode] = useState<string>("MH12345");
  useEffect(() => {
    const elementId = document.getElementById("header");

    const handleScroll = () => {
      if (elementId) {
        if (window.scrollY > 170) {
          elementId.classList.add("sticky");
        } else {
          elementId.classList.remove("sticky");
        }
      }
    };

    document.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const storedCode = localStorage.getItem("multyhealth_code") || "MH12345";
    setReferralCode(storedCode);
  }, []);

  return (
    <>
      <header
        className="header-area bg-white mb-4 rounded-bottom-15"
        id="header"
      >
        <div className="container-fluid p-0">
          <div className="row align-items-center">
            <div className="col-lg-5 col-sm-6">
              <div className="left-header-content">
                <ul className="d-flex align-items-center ps-0 mb-0 list-unstyled justify-content-center justify-content-sm-start">
                  <li className="hbm">
                    <button
                      className="header-burger-menu bg-transparent p-0 border-0"
                      onClick={toggleActive}
                    >
                      <i className="material-symbols-outlined fs-24">menu</i>
                    </button>
                  </li>

                  <li className="logo-box">
                    <Link to="/dashboard/ecommerce" className="logo">
                      <img
                        src="/images/logo.svg"
                        alt="logo"
                        width={100}
                        height={26}
                      />
                    </Link>
                    <Link to="/dashboard/ecommerce" className="logo white-logo">
                      <img
                        src="/images/white-logo.svg"
                        alt="logo"
                        width={100}
                        height={26}
                      />
                    </Link>
                  </li>

                </ul>
              </div>
            </div>

            <div className="col-lg-7 col-sm-6">
              <div className="right-header-content mt-2 mt-sm-0">
                <ul className="d-flex align-items-center justify-content-center justify-content-sm-end ps-0 mb-0 list-unstyled">
                  {/* <li className="header-right-item">
                    <DarkMode />
                  </li> */}

                  {/* <li className="header-right-item">
                    <ChooseLanguage />
                  </li> */}

                  {/* <li className="header-right-item">
                    <FullscreenButton />
                  </li> */}

                     

                  <li className="header-right-item d-block d-md-none">
                    <ReferralActions  referralCode={referralCode} />
                  </li>
                  <li className="header-right-item">
                    <CartIcon />
                  </li>

                  {/* <li className="header-right-item">
                    <Notifications />
                  </li> */}

                  <li className="header-right-item">
                    <Profile />
                  </li>

                  
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* HorizontalNavbar */}
        <HorizontalNavbar />
      </header>
    </>
  );
};

export default TopNavbar;
